import * as R from 'ramda'
import React from 'react'
import { useHistory, useParams } from 'react-router-dom'

import SurveyAccessFormModal from './index'
import useAxios, { mutate } from 'hooks/useAxios'
import useUser from 'hooks/useUser'
import { toast } from 'libs/toast'
import useSaveUserActivityLog, { ACTION_NAME } from 'hooks/useSaveUserActivityLog'

type Props = {
  surveyToken: string
}
function SurveyAccessFormMoalContianer({ surveyToken }: Props) {
  const url = `survey/survey/${surveyToken}/control-user-access/`
  const { data: users } = useAxios({ url })
  const { fetch: updateSurveyAccess } = useAxios({ url, method: 'post', skip: true })
  const saveUserActivityLog = useSaveUserActivityLog()

  const currentUser = useUser()
  const history = useHistory()
  const { surveyId } = useParams()

  if (!users || !currentUser) {
    return null
  }

  function onSubmit(userIds: number[]) {
    const data = {
      allowed_user_access: userIds,
    }
    updateSurveyAccess({
      data,
    })
      .then((response) => {
        mutate(url)
        if (_isRemoveYourself(response.data)) {
          toast.success(
            `You've removed yourself from the survey. Please contact another admin or manager if you'd like to be re-added.`
          )
          history.push('/')
        } else {
          toast.success('Survey access updated!')
        }

        saveUserActivityLog({
          action: ACTION_NAME.edit_survey_access,
          target: `sur_${surveyId}`,
          requestBody: data,
          statusCode: 200,
        })
      })
      .catch((error) => {
        toast.error('Oops, something went wrong')

        saveUserActivityLog({
          action: ACTION_NAME.edit_survey_access,
          target: `sur_${surveyId}`,
          requestBody: data,
          statusCode: error.response.status,
        })
      })
  }

  function _isRemoveYourself(users): boolean {
    const userMe = users.find((user) => user.user_id === currentUser.id)
    return !R.prop('has_permission', userMe)
  }

  return (
    <SurveyAccessFormModal
      defaultUsers={users}
      onChange={onSubmit}
      currentUserId={currentUser.id}
    />
  )
}

export default SurveyAccessFormMoalContianer



// WEBPACK FOOTER //
// ./src/components/SurveyAccessFormModal/container.tsx